import { SkeletonCard } from '../../../components/Skeleton';
import styles from './HomeFeedSkeleton.module.scss';

export interface HomeFeedSkeletonProps {
  /** Number of post card skeletons to show (default: 5) */
  count?: number;
  className?: string;
}

export function HomeFeedSkeleton({ count = 5, className }: HomeFeedSkeletonProps) {
  const classes = [styles.homeFeedSkeleton, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export default HomeFeedSkeleton;
